// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 3524) return "styles/app.366831e26a7e16876c00.css";
	// return url for filenames based on template
	return "" + chunkId + ".css";
};